module.exports = __webpack_public_path__ + "static/US1_modern-fbd9cd336e0c7dd404411e4e904a4ed3.png";